import React from 'react';
import { Button, Card, CardBody, UserAvatar } from '../common';

export const GMPickSelector = ({
  candidates,
  onSelect,
  loading,
  pot,
}) => {
  if (!candidates || candidates.length === 0) {
    return (
      <div className="text-center py-4 text-gray-500">
        No eligible candidates for GM Pick.
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="text-center mb-4">
        <h3 className="text-lg font-semibold">Select GM Pick</h3>
        <p className="text-sm text-gray-600">
          Choose a player to receive 2nd place in the pot distribution.
        </p>
        <p className="text-xs text-gray-500 mt-1">
          (MVP receives 1st place and is not eligible for GM Pick)
        </p>
      </div>

      <div className="grid gap-3">
        {candidates.map((candidate) => (
          <Card key={candidate.userId} className="hover:border-primary-300 transition-colors">
            <CardBody className="p-3">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <UserAvatar
                    displayName={candidate.displayName}
                    avatarUrl={candidate.avatarUrl}
                    size="md"
                  />
                  <div>
                    <p className="font-medium">{candidate.displayName}</p>
                  </div>
                </div>

                <Button
                  size="sm"
                  onClick={() => onSelect(candidate.userId)}
                  loading={loading}
                >
                  Select
                </Button>
              </div>
            </CardBody>
          </Card>
        ))}
      </div>
    </div>
  );
};
